export default __webpack_public_path__ + "static/media/History.23887059.png";